import "pages/DineInMenu/DineInMenu.css";
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import menuEn from "data/menu-en.json";
import menuPt from "data/menu-pt-PT.json";
import menuEs from "data/menu-es.json";
import menuFr from "data/menu-fr.json";
import BackToTop from "components/BackToTop.js";

const menus = {
  en: menuEn,
  pt: menuPt,
  es: menuEs,
  fr: menuFr
};

const DineInMenu = () => {
  const { t, i18n } = useTranslation();

  const lang = i18n.language.split('-')[0]
  const menuData = menus[lang];

  const [location, setLocation] = useState("tavira")
  
  // Set manu page title correctly
  useEffect(() => {
    document.title = "Menu - Umi Sushi";
  }, []);

  return (
    <div className="menu-container">
      <BackToTop />
      <div className="hero-banner">
        <span className="hero-header"><h1>{t('menu')}</h1></span>
        <span className="hero-hours">{t('menu-hours')}</span>
      </div>

      <div className="location-toggle" role="group" aria-label="Select a location">
        <button
          className={location === "tavira" ? "active" : ""}
          onClick={() => setLocation("tavira")}
        >
          Tavira
        </button>
        <button
          className={location === "olhao" ? "active" : ""}
          onClick={() => setLocation("olhao")}
        >
          Olhão
        </button>
      </div>

      <div className="content">
        

        {menuData.map((section, idx) => {
          const resolvedSection =
            section.variants?.[location]
              ? { ...section, ...section.variants[location] }
              : section;

          return (
          <div key={idx} className="menu-section">
            <h2>{resolvedSection.section}</h2>

            {resolvedSection.items.map((item, i) => (
              <div key={i} className="menu-item">
                <div className="item-name-price">
                  <span className="item-name">{item.name}</span>
                  {item.price && <span className="item-leader"></span>}
                  <span className="item-price">{item.price}</span>
                </div>
                {item.description && <div className="item-desc">{item.description}</div>}
              </div>
            ))}

            {resolvedSection.note && <p className="section-note">{section.note}</p>}
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default DineInMenu;
